export function formatDate(isoString, options = {}) {
  if (!isoString) return "";

  const date = new Date(
    isoString.endsWith("Z") ? isoString : isoString + "Z"
  );

  const defaultOptions = {
    year: "numeric",
    month: "short",
    day: "2-digit",
    hour: "2-digit",
    minute: "2-digit",
    hour12: true,
  };

  return date.toLocaleString("en-IN", {
    timeZone: "Asia/Kolkata", // 🔥 explicit IST
    ...defaultOptions,
    ...options,
  });
}

export function formatDateOnly(isoString) {
  if (!isoString) return "";

  const date = new Date(
    isoString.endsWith("Z") ? isoString : isoString + "Z"
  );

  return date.toLocaleDateString("en-IN", {
    timeZone: "Asia/Kolkata",
    year: "numeric",
    month: "short",
    day: "2-digit",
  });
}